// Expanded cultural events data for Sikkim Monasteries

const eventsData = [
  {
    id: 1,
    title: "Losar Festival",
    monastery: "Rumtek Monastery",
    date: "2025-03-01",
    description:
      "Celebrate the Tibetan New Year with vibrant dances, rituals, and traditional performances.",
    image: "/assets/images/culture-events-booking/Losar.png",
  },
  {
    id: 2,
    title: "Saga Dawa",
    monastery: "Pemayangtse Monastery",
    date: "2025-06-15",
    description:
      "Marking the birth, enlightenment, and nirvana of Buddha with special prayers and ceremonies.",
    image: "/assets/images/culture-events-booking/sagaDawa.png",
  },
  {
    id: 3,
    title: "Pang Lhabsol",
    monastery: "Tashiding Monastery",
    date: "2025-09-05",
    description:
      "Festival dedicated to Mount Khangchendzonga with warrior dances and sacred rituals.",
    image: "/assets/images/culture-events-booking/phanglbhasol.png",
  },
  {
    id: 4,
    title: "Drupka Teshi",
    monastery: "Enchey Monastery",
    date: "2025-07-27",
    description:
      "Commemorates Buddha's first teaching of the Four Noble Truths, marked with prayers and rituals.",
    image: "/assets/images/culture-events-booking/Drupka.png",
  },
  {
    id: 5,
    title: "Kagyed Dance",
    monastery: "Phodong Monastery",
    date: "2025-12-06",
    description:
      "Colorful Cham masked dances symbolizing the victory of good over evil, performed by monks.",
    image: "/assets/images/culture-events-booking/kagyed.png",
  },
  {
    id: 6,
    title: "Bumchu Festival",
    monastery: "Tashiding Monastery",
    date: "2025-02-21",
    description:
      "A sacred water ritual believed to predict the prosperity and fortune of the year.",
    image: "/assets/images/culture-events-booking/bhumchu.png",
  },
  {
    id: 7,
    title: "Maghe Sankranti",
    monastery: "Ralong Monastery",
    date: "2025-01-14",
    description:
      "Winter harvest festival celebrated with traditional dances, local fairs, and rituals.",
    image: "/assets/images/culture-events-booking/maghe.png",
  },
  {
    id: 8,
    title: "Cham Dance Festival",
    monastery: "Enchey Monastery",
    date: "2025-11-20",
    description:
      "Sacred masked Cham dance performed by monks to ward off evil and bring blessings.",
    image: "/assets/images/culture-events-booking/Cham.png",
  },
  {
    id: 9,
    title: "Lhabab Düchen",
    monastery: "Ralong Monastery",
    date: "2025-10-22",
    description:
      "Commemorates Buddha's descent from heaven after teaching his mother, celebrated with prayers.",
    image: "/assets/images/culture-events-booking/Lhabab.png",
  },
  {
    id: 10,
    title: "Phanglhabsol Cham",
    monastery: "Pemayangtse Monastery",
    date: "2025-09-06",
    description:
      "Warrior dances performed by monks with traditional attire to honor the guardian deities.",
    image: "/assets/images/culture-events-booking/phangcham.png",
  },
];

export default eventsData;
